module.exports = __webpack_public_path__ + "static/Dunedin-883ae7938b72df7eb6a9e5232ccb0f19.jpg";